export const inventoryV2 = {
	tabs: {
		storages: "Almacenes",
		inventories: "Inventarios",
	},
	byStorage: {
		actions: {
			createInventory: "Inventariar almacén",
		},
		bigNumbers: {
			total: "Inventarios creados",
			approved: "Inventarios cerrados",
			open: "Inventarios abiertos",
			inReview: "Inventarios por aprobar",
			errorMessage: "No se pudieron cargar los totales.",
		},
		filters: {
			keywordPlaceholder: "Buscar por nombre del inventario",
			period: "Período",
			allStatuses: "Todos los estados",
			categoriesPlaceholder: "Categorías",
			clear: "Limpiar filtros",
		},
		table: {
			columns: {
				status: "Estado",
				name: "Inventario",
				categories: "Categorías",
				worker: "Inventarista",
				updatedAt: "Última edición",
				actions: "Acciones",
			},
			categoriesCount_one: "{{count}} categoría",
			categoriesCount_other: "{{count}} categorías",
			rowActions: {
				view: "Ver",
				continue: "Continuar",
				awaiting: "Esperando",
				rejected: "Rechazado",
				edit: "Editar",
				delete: "Eliminar",
			},
			status: {
				closed: "Cerrado",
				open: "Abierto",
				awaitingApproval: "Esperando aprobación",
				rejected: "Rechazado",
			},
			empty: {
				title: "Ningún inventario en este almacén",
				description: "Comienza un inventario para acompañar este almacén.",
				action: "Inventariar almacén",
			},
		},
	},
	createInventoryDrawer: {
		titleCreate: "Inventariar almacén",
		titleEdit: "Editar inventario",
		fields: {
			name: {
				label: "Nombre del inventario",
				placeholder: "Ej.: Mensual Mayo",
				requiredError: "Indica el nombre del inventario",
				maxLengthError:
					"El nombre del inventario debe tener como máximo {{maxLength}} caracteres",
			},
			categoriesIds: {
				label: "Categorías",
				placeholder: "Selecciona las categorías",
				requiredError: "Selecciona al menos una categoría",
			},
			storage: {
				label: "Almacén",
				placeholder: "Selecciona un almacén",
				requiredError: "Selecciona un almacén",
			},
			stockistName: {
				label: "Almacenista",
			},
		},
		buttons: {
			cancel: "Cancelar",
			create: "Iniciar conteo",
			save: "Guardar cambios",
		},
	},
	list: {
		filters: {
			storagesPlaceholder: "Todos los almacenes",
		},
		table: {
			columns: {
				storage: "Almacén",
			},
			empty: {
				title: "Ningún inventario encontrado",
				description: "No encontramos inventarios para los almacenes de este lugar.",
			},
		},
	},
	inventoryCount: {
		header: {
			name: "Nombre",
			status: "Estado",
			storage: "Almacén",
			stockist: "Almacenista",
			createdAt: "Creado en",
			updatedAt: "Última actualización",
			editButton: "Editar",
			editApprovedTooltip: "Los inventarios completados no se pueden editar.",
			statuses: {
				open: "Abierto",
				in_review: "Esperando aprobación",
				approved: "Completado",
				reopened: "Reabierto",
			},
		},
		filters: {
			productNamePlaceholder: "Buscar producto",
			categoriesPlaceholder: "Todas las categorías",
			clear: "Limpiar",
		},
		actions: {
			saveDraft: "Guardar borrador",
			delete: "Eliminar",
			deleteApprovedTooltip: "Los inventarios completados no se pueden eliminar.",
			cancel: "Cancelar",
			saveSuccess: "Borrador guardado.",
			saveError: "No se pudo guardar el borrador.",
			deleteSuccess: "Inventario eliminado.",
			deleteError: "No se pudo eliminar el inventario.",
		},
		accordion: {
			itemsSubtitle: "{{total}} elementos",
			counterBadge: "{{inventoried}}/{{total}} elementos contados",
		},
		productRow: {
			imageAlt: "Imagen del producto",
			columns: {
				product: "Producto",
				count: "Conteo",
				newCount: "Nuevo conteo",
				unit: "Unidad",
			},
			units: {
				milliliter: "Mililitros",
				liter: "Litros",
				kilogram: "Kilogramos",
				gram: "Gramos",
				unit: "Unidad",
			},
		},
		productRowAdmin: {
			columns: {
				systemCount: "Cant. en sistema",
				adjustment: "Ajuste",
				loss: "Pérdida",
				differenceQty: "Diferencia en cant.",
				differenceValue: "Diferencia en R$",
			},
		},
		submit: {
			stockist: {
				button: "Enviar para aprobación",
				dialogTitle: "Enviar para aprobación",
				dialogBody:
					"El conteo se enviará para aprobación y quedará en espera de revisión. ¿Deseas continuar?",
				confirm: "Enviar",
				cancel: "Cancelar",
				success: "Inventario enviado para aprobación.",
				error: "No se pudo enviar el inventario.",
			},
			admin: {
				button: "Concluir inventario",
				dialogTitle: "Concluir inventario",
				dialogBody:
					"Al concluir, el conteo se aplicará a las cantidades en stock. Esta acción no se puede deshacer. ¿Deseas continuar?",
				confirm: "Concluir",
				cancel: "Cancelar",
				success: "Inventario concluido.",
				error: "No se pudo concluir el inventario.",
			},
		},
		loading: "Cargando...",
		error: {
			title: "No se pudo cargar el inventario",
			body: "Intenta nuevamente en un momento.",
			backToInventories: "Volver a inventarios",
		},
		permissions: {
			noAccess: "No tienes permiso para ver esta página.",
		},
		backToStorage: "Volver al almacén",
		itemsHeader: "Elementos del almacén",
	},
	deleteInventoryDialog: {
		title: "¿Eliminar inventario?",
		warningMessagePrefix: "¿Seguro que deseas eliminar el inventario ",
		warningMessageSuffix: "? Esta acción no se puede deshacer.",
		fallbackName: "este inventario",
		submit: "Eliminar inventario",
	},
};

export type InventoryV2Translations = typeof inventoryV2;
